import { useSelector } from "react-redux";
import { currentStep, Media, STEPS } from "../../../store";
import { useCallback } from "react";
import { Stepper } from "../../components";
import { useTranslation } from "react-i18next";

export const Header = () => {
  const { t } = useTranslation();

  const step = useSelector(currentStep);

  const getTitle = useCallback(() => {

    const index = STEPS.indexOf(step);

    switch (step) {
      case Media.SELECT:
        return `${t("upload.header.step", { step: index + 1 })} ${t("upload.header.selectTitle")}`;
      case Media.REVIEW:
        return `${t("upload.header.step", { step: index + 1 })} ${t("upload.header.reviewTitle")}`;
      case Media.UPLOAD:
        return `${t("upload.header.step", { step: index + 1 })} ${t("upload.header.uploadingTitle")}`;
      case Media.CONFIRMATION:
        return `${t("upload.header.step", { step: index + 1 })} ${t("upload.header.confirmationTitle")}`;
      default:
    }
  }, [step, t])

  return (
    <div className="header">
      <Stepper />
      <h5>{getTitle()}</h5>
    </div>
  )
}